module.exports = __webpack_public_path__ + "img/active.49d3fcdf.jpg";